<div class="overlay-wrapper">
    <div class="overlay-cont">
        @for (category of categories | categoryFilter: primaryBrandId; track category) {
            <div
                class="category-row"
                (click)="selectCategory(category.id)"
                [ngClass]="{ 'category-selected': category.id === selectedId }">
                <div class="category-name">{{ category.label }}</div>
                <div class="category-count">{{ padNumber(categoryCount[category.id]) }}</div>
            </div>
        }
    </div>
</div>
